import React from 'react';
import { ResetPasswordForm } from '../features/auth/components/ResetPasswordForm';

export const ResetPasswordPage: React.FC = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-background-page relative overflow-hidden">
            {/* Background decoration */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
                <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-accent-primary/5 rounded-full blur-[100px]" />
                <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-orange-400/5 rounded-full blur-[100px]" />
            </div>

            <div className="z-10 w-full flex justify-center px-4">
                <ResetPasswordForm />
            </div>
        </div>
    );
};
